import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const WebDevelopment = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "Development is an extension of the design process, not a separate phase. We work from our own design files (or yours), build to component-level precision, and test across devices and browsers as we go — not as an afterthought at the end. We use modern frameworks where they make sense, and resist the temptation to over-engineer things that should stay simple.",
    },
    {
      title: 'Delivery',
      description:
        "Production-ready code: clean, commented, and version-controlled. You'll receive a codebase you can hand to any developer and they'll understand it, component documentation, accessibility audit, cross-browser and responsive testing report, and deployment support. No black boxes. No mystery dependencies.",
    },
    {
      title: 'Results',
      description:
        "Sites and apps that perform — technically and commercially. Fast load times, strong Core Web Vitals, zero 'it looked different in the design' conversations, and a codebase that doesn't need to be rewritten in a year because it was built on a foundation that actually works.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="Web Development Services | Heretic Studio"
        description="We build fast, scalable websites and applications that are reliable, maintainable, and ready to grow with your business."
      />
      <div className="studio-page service-page service-page--web-development">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">Web Development</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Built to scale, built to last</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Fast, scalable websites and applications that grow with your business.
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default WebDevelopment;
